<app-spinner-service></app-spinner-service>

<div class="p-4">
  <p-steps [model]="steps" [(activeIndex)]="activeIndex" [readonly]="true"></p-steps>

  <div class="mt-4">
    <div *ngIf="activeIndex === 0">
      <form [formGroup]="importForm" class="form-grid pt-2 pl-6 pr-6 pb-6">
        <fieldset class="form-block">
          <legend class="form-block-legend">Dados da Importação</legend>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label for="contaBancariaId">Conta Bancária <span class="required">*</span></label>
              <p-dropdown 
                [options]="contasBancarias" 
                optionLabel="label" 
                formControlName="contaBancariaId"
                placeholder="Selecione uma conta bancária" 
                id="contaBancariaId" 
                optionValue="id" 
                [style]="{'width':'100%'}"
                [ngClass]="{'invalid-field': importForm.get('contaBancariaId')?.invalid && importForm.get('contaBancariaId')?.touched}">
              </p-dropdown>
              <small *ngIf="importForm.get('contaBancariaId')?.invalid && importForm.get('contaBancariaId')?.touched" class="error-message">
                Conta bancária é obrigatória.
              </small>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="data">Período <span class="required">*</span></label>
              <p-calendar
                [touchUI]="true"
                formControlName="data"
                (onSelect)="importForm.get('data').markAsTouched()"
                [readonlyInput]="true"
                id="data"
                [minDate]="dataCriacaoUsuario"
                [dateFormat]="'mm/yy'"
                [view]="'month'"
                [monthNavigator]="true"
                [yearNavigator]="true"
                placeholder="Selecione o período"
                [ngClass]="{'invalid-field': importForm.get('data')?.invalid && importForm.get('data')?.touched}">
              </p-calendar>
              <small *ngIf="importForm.get('data')?.invalid && importForm.get('data')?.touched" class="error-message">
                Período é obrigatório.
              </small>
            </div>
          </div>
        </fieldset>
      </form>
    </div>

    <div *ngIf="activeIndex === 1">
      <fieldset class="form-block">
        <legend class="form-block-legend">Selecione a forma de importação</legend>
        <p-tabView (onChange)="limpaUploadedFiles()">
          <p-tabPanel header="Arquivo .ofx">
            <p-fileUpload #fileUploadOfx mode="advanced" [multiple]="false" accept=".ofx" [maxFileSize]="1000000"
              (onSelect)="onFileSelectOfx($event)" [customUpload]="true" [showUploadButton]="false"
              [showCancelButton]="false" chooseLabel="Selecionar extrato" [fileLimit]="1"
              invalidFileLimitMessageDetail="O número máximo de arquivos permitidos é {0}."
              invalidFileTypeMessageSummary="{0} tipo de arquivo inválido."
              invalidFileTypeMessageDetail="Apenas arquivos .ofx são permitidos."
              invalidFileSizeMessageSummary="{0}: Tamanho de arquivo inválido."
              invalidFileSizeMessageDetail="O tamanho máximo permitido é {0}." styleClass="w-full border-round-xl"
              [disabled]="uploadedFiles.length >= 1">
              <ng-template pTemplate="content">
                <div *ngIf="uploadedFiles.length > 0" class="p-d-flex p-align-center p-p-3">
                  <h5 class="p-d-flex p-align-center p-mb-3">Arquivos Selecionados:</h5>
                  <ul class="p-m-0">
                    <li *ngFor="let file of uploadedFiles; let i = index"
                      class="p-d-flex p-align-center p-jc-between p-mb-2 p-p-2">
                      <span>{{file.name}} - {{formatFileSize(file.size)}}</span>
                      <p-button icon="pi pi-times" [style]="{'height': '2.1rem', 'width': '2rem'}" [rounded]="true"
                        (click)="limpaUploadedFiles()" severity="danger"></p-button>
                    </li>
                  </ul>
                </div>
              </ng-template>
            </p-fileUpload>
          </p-tabPanel>

          <p-tabPanel header="Planilha modelo">
            <div class="flex justify-content-end mb-3">
              <p-button label="Baixar Planilha Modelo" icon="pi pi-download" (click)="baixarPlanilhaModelo()"
                class="p-button-raised">
              </p-button>
            </div>

            <p-fileUpload #fileUploadXlsx mode="advanced" [multiple]="false" accept=".xlsx"
              (onSelect)="onFileSelectXlsx($event)" [customUpload]="true" [showUploadButton]="false"
              [showCancelButton]="false" chooseLabel="Selecionar planilha preenchida" [fileLimit]="1"
              invalidFileLimitMessageDetail="O número máximo de arquivos permitidos é {0}."
              invalidFileTypeMessageSummary="{0} tipo de arquivo inválido."
              invalidFileTypeMessageDetail="Apenas arquivos .xlsx são permitidos."
              invalidFileSizeMessageSummary="{0}: Tamanho de arquivo inválido."
              invalidFileSizeMessageDetail="O tamanho máximo permitido é {0}." styleClass="w-full border-round-xl"
              [disabled]="uploadedFiles.length >= 1">
              <ng-template pTemplate="content">
                <div *ngIf="uploadedFiles.length > 0" class="p-d-flex p-align-center p-p-3">
                  <h5 class="p-d-flex p-align-center p-mb-3">Arquivos Selecionados:</h5>
                  <ul class="p-m-0">
                    <li *ngFor="let file of uploadedFiles; let i = index"
                      class="p-d-flex p-align-center p-jc-between p-mb-2 p-p-2">
                      <span>{{file.name}} - {{formatFileSize(file.size)}}</span>
                      <p-button icon="pi pi-times" [style]="{'height': '2.1rem', 'width': '2rem'}" [rounded]="true"
                        (click)="limpaUploadedFiles()" severity="danger"></p-button>
                    </li>
                  </ul>
                </div>
              </ng-template>
            </p-fileUpload>
          </p-tabPanel>
        </p-tabView>
      </fieldset>
    </div>
    <div *ngIf="activeIndex === 2 && temLinhasExtrato()">
      <fieldset class="form-block">
        <legend class="form-block-legend">Confirmar Importação</legend>
        <div class="alert-info mb-3">
          <i class="pi pi-info-circle"></i>
          <span>
            <strong>Atenção:</strong> Por padrão, a conta contrapartida sugerida será utilizada. 
            Marque o checkbox "Alterar Conta" para liberar a edição e escolher uma conta diferente.
            Se não marcar, a conta pré-carregada será mantida.
          </span>
        </div>
        <div *ngFor="let extrato of extratos" class="mb-4">
          <p-panel 
            [header]="extrato.contaBancaria ? 'Banco: ' + obterNomeBancoPorCodigo(extrato.contaBancaria.banco) : 'Extrato sem conta bancária'">
            <p *ngIf="extrato.contaBancaria">Agência: {{ extrato.contaBancaria.agencia }} | Conta: {{ extrato.numeroConta }}</p>
            <p-table [value]="extrato.linhasExtratos" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
              currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
              [rowsPerPageOptions]="[10, 25, 50]" class="custom-table">
              <ng-template pTemplate="header">
                <tr>
                  <th>Data</th>
                  <th>Descrição</th>
                  <th>Valor</th>
                  <th>Conta Contrapartida Natureza</th>
                  <th>Alterar Conta</th>
                  <th>Conta Contrapartida</th>
                  <th class="text-center">Ações</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-linhaExtrato>
                <tr>
                  <td>
                    <div class="date-content">
                      <i class="pi pi-calendar date-icon"></i>
                      <span class="date-text">{{ formatarDataOperacao(linhaExtrato.dataOperacao) }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="description-content">
                      <i class="pi pi-align-left description-icon"></i>
                      <input id="descricao" pInputText class="description-input" [value]="linhaExtrato.descricao"
                        (focus)="salvarValorOriginal(linhaExtrato)" (blur)="confirmaAlteracao($event, linhaExtrato)" />
                    </div>
                  </td>
                  <td>
                    <div class="value-content">
                      <i class="pi pi-dollar value-icon"></i>
                      <span class="value-text">{{ linhaExtrato.valor | currency }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="nature-content">
                      <i class="pi pi-tag nature-icon"></i>
                      <span class="nature-text">{{ getTipoTransacaoLabel(linhaExtrato.tipoTransacao) }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="checkbox-content">
                      <p-checkbox [(ngModel)]="linhaExtrato.permiteAlterarContaContrapartida" 
                        [binary]="true"
                        (onChange)="onCheckboxChange(linhaExtrato)">
                      </p-checkbox>
                    </div>
                  </td>
                  <td>
                    <div class="account-content">
                      <i class="pi pi-bookmark account-icon"></i>
                      <p-dropdown [options]="contasContabeis" [(ngModel)]="linhaExtrato.contaContabilId" optionLabel="nome"
                        optionValue="id" placeholder="Selecione uma conta" [style]="{'width': '100%'}" [filter]="true"
                        filterPlaceholder="Buscar conta..." styleClass="account-dropdown" [appendTo]="'body'"
                        [disabled]="!linhaExtrato.permiteAlterarContaContrapartida"></p-dropdown>
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="actions-content">
                      <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info action-button"
                        (click)="verDetalhesLinhaExtrato(linhaExtrato)" pTooltip="Ver Detalhes" tooltipPosition="top">
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7" class="text-center">
                    <i class="pi pi-file-excel" style="font-size: 2rem; color: #6c757d; margin-bottom: 1rem;"></i>
                    <p>Nenhuma linha de extrato encontrada.</p>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-panel>
        </div>
      </fieldset>
    </div>
  </div>

  <div class="form-actions mt-4">
    <p-button *ngIf="activeIndex > 0" label="Voltar" icon="pi pi-chevron-left" (onClick)="onPreviousStep()"></p-button>
    <p-button label="Avançar" icon="pi pi-chevron-right" (onClick)="onNextStep()" *ngIf="activeIndex !== 2"
      [disabled]="(activeIndex === 0 && (!importForm.get('contaBancariaId')?.valid || !importForm.get('data')?.valid))">
    </p-button>
    <p-button label="Salvar" icon="pi pi-save" (onClick)="this.confirmarImportacao()" *ngIf="activeIndex === 2"
      [disabled]="!temLinhasExtrato()">
    </p-button>
  </div>
</div>

<p-dialog header="Atenção" [(visible)]="displayDialog" modal="modal" [closable]="true" (onHide)="cancelarImportacao()"
  [style]="{width: '50vw', 'max-width': '600px', 'min-width': '300px'}"
  [contentStyle]="{'overflow': 'visible', 'padding': '1rem'}">
  <div class="dialog-content">
    <h4>Já há um extrato registrado para este período nesta conta bancária.</h4>
    <h4>Deseja fazer a substituição do extrato já existente?</h4>
  </div>
  <p-footer class="dialog-footer">
    <p-button label="Continuar" icon="pi pi-check" (click)="continuarImportacao()"></p-button>
    <p-button label="Cancelar" icon="pi pi-times" severity="danger" (click)="cancelarImportacao()"></p-button>
  </p-footer>
</p-dialog>

<p-confirmDialog></p-confirmDialog>

<app-info-dialog 
  [visible]="displayDialogSemMovimentacao" 
  (visibleChange)="displayDialogSemMovimentacao = $event"
  [config]="infoDialogConfig"
  (onClose)="onInfoDialogClose()">
</app-info-dialog>
